"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ModalGroupState_1 = require("./ModalGroupState");
/** Platform UI Components */
var SimpleModal_1 = require("@idp/duc/components/containers/SimpleModal");
/** CMS */
/** Stylesheets */
var utilityStyles = require("../../../styles/utilities.scss");
var styles = require("./ModalGroup.scss");
/** LOB Components */
var PageLevelHeading_1 = require("../../common/PageLevelHeading");
var PageLevelHeadingProps_1 = require("../../common/PageLevelHeading/PageLevelHeadingProps");
var CtaButtonGroup_1 = require("../../common/CtaButtonGroup");
var CtaButtonGroupProps_1 = require("../../common/CtaButtonGroup/CtaButtonGroupProps");
/** Api, Reporting, Mappers, Request, Response */
var ModalGroup = /** @class */ (function (_super) {
    __extends(ModalGroup, _super);
    function ModalGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new ModalGroupState_1.default();
        _this.onXIconBtnClick = _this.onXIconBtnClick.bind(_this);
        _this.onPrimaryBtnClick = _this.onPrimaryBtnClick.bind(_this);
        _this.onSecondaryBtnLinkClick = _this.onSecondaryBtnLinkClick.bind(_this);
        return _this;
    }
    ModalGroup.prototype.renderChildren = function () {
        if (this.props.children) {
            return (React.createElement(React.Fragment, null, this.props.children));
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { dangerouslySetInnerHTML: {
                        __html: this.props.data.modalTitle,
                    } })));
        }
    };
    ModalGroup.prototype.onXIconBtnClick = function () {
        this.props.xIconBtnEvents.onClick();
    };
    ModalGroup.prototype.onPrimaryBtnClick = function () {
        this.props.primaryBtnEvents.onClick();
    };
    ModalGroup.prototype.onSecondaryBtnLinkClick = function () {
        this.props.secondaryBtnLinkEvents.onClick();
    };
    ModalGroup.prototype.render = function () {
        var loginModalTestId = 'Login_' + this.props.testId + '_Modal';
        return (React.createElement(SimpleModal_1.default, { accessibilityTitle: this.props.data.modalTitle + ' Modal', show: this.state.showModal, close: this.onXIconBtnClick, root: "root", size: this.props.options.size, sizing: this.props.options.sizing, testId: 'Login_' + this.props.testId + '_Modal' },
            React.createElement("div", { className: [
                    styles.loginModalGroupWrapper,
                    this.props.options.className,
                ].join(' ') },
                React.createElement(PageLevelHeading_1.default, { data: {
                        headingText: this.props.data.modalTitle,
                    }, options: {
                        type: PageLevelHeadingProps_1.PageLevelHeadingType.HEADING_MODAL,
                    }, testId: loginModalTestId + '_Header' }),
                React.createElement("div", { className: [
                        utilityStyles.marTXs,
                    ].join(' ') }, this.renderChildren()),
                React.createElement("div", { className: [
                        utilityStyles.marTSmAll,
                    ].join(' ') },
                    React.createElement(CtaButtonGroup_1.default, { data: {
                            primaryBtnText: this.props.data.primaryBtnText,
                            secondaryBtnLinkText: this.props.data.secondaryBtnLinkText,
                            disabledPrimaryBtn: this.props.data.disabledPrimaryBtn,
                        }, options: {
                            type: CtaButtonGroupProps_1.CtaButtonGroupType.BUTTON_REVERSE_LEFT,
                        }, primaryBtnEvents: {
                            onClick: this.onPrimaryBtnClick,
                        }, secondaryBtnLinkEvents: {
                            onClick: this.onSecondaryBtnLinkClick,
                        } })))));
    };
    return ModalGroup;
}(React.Component));
exports.default = ModalGroup;
//# sourceMappingURL=ModalGroup.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/ModalGroup/ModalGroup.js
// module id = 1673
// module chunks = 8